import React, { lazy, Suspense } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import "../styles/layout.css"
import HeaderSection from '../containers/HeaderSection/HeaderSection';
import SidebarNavigation from '../containers/SidebarNavigation/SidebarNavigation';
import { Content } from 'antd/es/layout/layout';
import UserDashboard from '../pages/userDashboard';
import RequestAccess from '../pages/requestAccess';
import Login from '../pages/login';
import RmPendingRequest from '../pages/rmPendingRequest';
import { getIsUserLoggedIn, getUserAccessData } from '../utilities/sessionHelper';
import OrderDashboard from '../pages/orderDashboard';
import { checkAccess, getUserRole } from '../utilities/CommonHelper';
import { Layout, message } from 'antd';
import PoDashboard  from '../pages/poDashboard';
import SowAgeingReportContainer from '../containers/SOWAgeingReportContainer/sowAgeingReportContainer';
import SowRevenueContainer from '../containers/SOWRevenueContainer/sowRevenueContainer';
import OboDashboard from '../pages/oboDashboard';
import RevenueForecaste from '../pages/RevenueForecaste';
import RevenueForecastingPOC from '../pages/RevenueForecastingPOC';
import OboReportContainer from '../containers/OBOReportContainer/oboReportContainer';
import OboDashboardV2Page from '../pages/oboDashboardV2';
import BCPReportContainer from '../containers/BCPReportContainer/bcpReportContainer';



const PrivateRoute: React.FC<{
  path: string;
  role: string | null;
  isAuthenticated: boolean;
  fallbackPath?: string;
}> = ({ path, role, isAuthenticated, fallbackPath }) => {
      const history= useHistory();
      const getcomponent=(path:string,props?:any)=>{
        let role= getUserRole(getUserAccessData()?.roleAccessMap)||"";
        if(path==="/userDashboard"){
          let flag=!checkAccess(role,"User Management",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to User Management page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          return <UserDashboard/>
        }else if(path==="/orderDashboard"){
          let flag=!checkAccess(role,"Order Dashboard",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to Order Dashboard page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          return <OrderDashboard/>
        }else if(path==="/obo-report"){
          let flag=!checkAccess(role,"Reports",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to OBO Report page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          // return <Suspense fallback={<div>Loading...</div>}><OboReportContainer/></Suspense>
          return <Suspense fallback={<div>Loading...</div>}><OboDashboardV2Page/></Suspense>
        }
        else if(path==="/obo-report-old"){
          let flag=!checkAccess(role,"Reports",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to OBO Report page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          // const OboReportContainer = lazy(() => import('../containers/OBOReportContainer/oboReportContainer.js'));
          return <Suspense fallback={<div>Loading...</div>}><OboReportContainer/></Suspense>
          // return <Suspense fallback={<div>Loading...</div>}><OboDashboard/></Suspense>
        }
        else if(path==="/obo-dashboard-v2"){
          let flag=!checkAccess(role,"Reports",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to OBO Dashboard V2");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          return <Suspense fallback={<div>Loading...</div>}><OboDashboardV2Page/></Suspense>
        }
        else if(path==="/sow-ageing-report"){
          let flag=!checkAccess(role,"Reports",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to SOW Ageing Report page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          // const OboReportContainer = lazy(() => import('../containers/OBOReportContainer/oboReportContainer'));
          return <Suspense fallback={<div>Loading...</div>}><SowAgeingReportContainer/></Suspense>
        }
        else if(path==="/sow-revenue-report"){
          let flag=!checkAccess(role,"Reports",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to SOW Revenue Report page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          return <Suspense fallback={<div>Loading...</div>}><SowRevenueContainer/></Suspense>
        }
        else if(path==="/consolidated-revenue-forecasting"){
          let flag=!checkAccess(role,"Reports",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to Consolidated Revenue Forecasting page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          return <Suspense fallback={<div>Loading...</div>}><RevenueForecastingPOC/></Suspense>
        }
        else if(path==="/revenue-forecasting-poc"){
          let flag=!checkAccess(role,"Reports",getUserAccessData()?.roleAccessMap[role],"noAccess");
          if(!flag){
            message.error("You don't have access to Revenue Forecasting (Old) page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          return <Suspense fallback={<div>Loading...</div>}><RevenueForecaste/></Suspense>
        }
        else if(path==="/bcp-report"){
          const roleLower = role.toLowerCase();
          const isAdminOrSuperuser = roleLower.includes('admin') || roleLower.includes('superuser') || roleLower.includes('super user');
          if(!isAdminOrSuperuser){
            message.error("You don't have access to BCP Report page");
            setTimeout(()=>{
              history.push("/");
            },200)
          }
          return <Suspense fallback={<div>Loading...</div>}><BCPReportContainer/></Suspense>
        }
        // else if(path==="/poDashboard"){
        //   let flag=!checkAccess(role,"Order Dashboard",getUserAccessData()?.roleAccessMap[role],"noAccess");
        //   if(!flag){
        //     message.error("You don't have access to Order Dashboard page");
        //     setTimeout(()=>{
        //       history.push("/");
        //     },200)
        //   }
        //   return <PoDashboard/>
        // }
        //dummy text
        else if(path==="/requestAccess"){
          return <RequestAccess type= {props?props:"new"}/>
        }else if(path==="/rmPendingRequest"){
          return<RmPendingRequest/>
        }
        return <Login/>;
      }
  if(getIsUserLoggedIn()){
    if(localStorage.getItem("redirectUrl")){
      let redirectUrl=localStorage.getItem("redirectUrl") || "";
      localStorage.removeItem("redirectUrl");
      return <Redirect to={{ pathname: redirectUrl, state: { from: path } }} />;
    }
    if(path==="/rmPendingRequest"){
      return <Route path={path} 
        render={()=>(
          <Layout>
            <HeaderSection/>
            <Layout className='layout-body'>
              {role && <SidebarNavigation locationPath={window.location.pathname}/>}
              <Content className={role?'layout-content':'layout-content-without-slider'}>
                {getcomponent(path)}
              </Content>
            </Layout>
          </Layout>
        )} 
      />;
    }
    if (
      //happy path
      role

      //if you want to edit the roles , redirect from rmPendingRequest
      // false

      // if want to access userDashboard 
      // true
      ) {
        let previouspathprops:any=history?.location?.state;
        if(path==="/requestAccess"&& previouspathprops?.type ){
          return <Route path={path} 
            render={()=>(
              <Layout>
                <HeaderSection/>
                <Layout className='layout-body'>
                  {(window.location.pathname=="/requestAccess" && previouspathprops ) && <SidebarNavigation locationPath={window.location.pathname}/>}
                  <Content className={role?'layout-content':'layout-content-without-slider'}>
                    {getcomponent(path,previouspathprops?.type?previouspathprops.type:null)}
                  </Content>
                </Layout>
              </Layout>
            )} 
          />;
        }else{
          return <Route path={path} 
            render={()=>(
              <Layout>
                <HeaderSection/>
                <Layout className='layout-body'>
                  {window.location.pathname!=="/requestAccess" && <SidebarNavigation locationPath={window.location.pathname}/>}
                  <Content className={role?'layout-content':'layout-content-without-slider'}>
                    {getcomponent(path)}
                  </Content>
                </Layout>
              </Layout>
            )} 
          />;
        }
      
    } else {
      if(path==="/requestAccess"){
         
        let previouspathprops:any=history?.location?.state;
        return <Route path={path} 
          render={()=>(
            <Layout>
              <HeaderSection/>
              <Layout className='layout-body'>
                {(window.location.pathname=="/requestAccess" && previouspathprops ) && <SidebarNavigation locationPath={window.location.pathname}/>}
                <Content className={role?'layout-content':'layout-content-without-slider'}>
                  {getcomponent(path,previouspathprops?.type?previouspathprops.type:null)}
                </Content>
              </Layout>
            </Layout>
          )} 
        />;
      } else {
        return <Redirect to={fallbackPath || "/requestAccess"} />;
      }
    }
  } else {
    if(path==="/rmPendingRequest"){
      localStorage.setItem("redirectUrl", "/rmPendingRequest");
      return <Route path={path} 
        render={()=>(
          <Redirect to={{ pathname: "/login", state: { from: path } }} />
        )} 
      />;
    }
    return <Redirect to={fallbackPath || "/login"} />;
  }
};

export default PrivateRoute;